/**
 * Sprint S13.1.A — placeholder step rendered для steps 2-7 не yet
 * implemented. S13.1.B replaces these с real components.
 */
import { useTranslation } from "react-i18next";
import { useOnboardingStore, STEP_ORDER } from "@/stores/onboardingStore";


export function StepStub() {
  const { t } = useTranslation();
  const currentStepIndex = useOnboardingStore((s) => s.currentStepIndex);
  const stepId = STEP_ORDER[currentStepIndex];

  return (
    <div className="rounded-xl border border-dashed border-cream-border bg-cream-light p-8 text-center">
      <p className="font-medium text-navy">
        {t("onboarding.stub.title", { step: stepId })}
      </p>
      <p className="mt-2 text-[13px] text-taupe">
        {t("onboarding.stub.subtitle")}
      </p>
    </div>
  );
}
